import React from 'react'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
// @ts-ignore
import { Button, MailSolid } from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'
import { selectV4ScheduledReportInfo } from 'features/scheduledReport/selectors'
import { usePageConfigUser } from 'hooks/usePageConfig'
import { AutomationId } from 'utils/automationUtil'
import {
  openScheduledReportSubscriptionModal,
  openScheduledReportUnsubscriptionModal
} from 'features/scheduledReport/scheduledReportSlice'

const StyledButton = styled(Button)`
  white-space: nowrap;
`

const StyledButtonContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

const ReportSubscribeButton = () => {
  const theme = useDisplayTheme()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const scheduledReportInfo = useAppSelector(selectV4ScheduledReportInfo)
  const userConfig = usePageConfigUser()
  const isSubscribed = scheduledReportInfo?.subscriptions?.find(
    (subscription) => subscription?.subscriberId === userConfig.userProfileId
  )

  return (
    <>
      {isSubscribed ? (
        <StyledButton
          mode={theme}
          data-testid={AutomationId.dashboard.report.unSubscribeButton}
          color="secondary"
          startIcon={<MailSolid fontSize={16} />}
          onClick={() => {
            dispatch(openScheduledReportUnsubscriptionModal())
          }}>
          <StyledButtonContent>{t('unsubscribeReport')}</StyledButtonContent>
        </StyledButton>
      ) : (
        <StyledButton
          mode={theme}
          data-testid={AutomationId.dashboard.report.subscribeButton}
          color="secondary"
          startIcon={<MailSolid fontSize={16} />}
          onClick={() => {
            dispatch(openScheduledReportSubscriptionModal())
          }}>
          <StyledButtonContent>{t('subscribeReport')}</StyledButtonContent>
        </StyledButton>
      )}
    </>
  )
}

export default ReportSubscribeButton
